import React from 'react'
import { InputContainer } from '../../../../../common/components/form/form.module'
import _ from 'lodash';

export default function ModalTasksComponent({
    Close,
    handleItemSubmit,
    selectEventTasks,
    ScheduledTaskType,
    sheduledType,
    platForms,
    configurationItem,
    onInnerBasicFormChange
}: any) {



    return (
        <div className="w-full p-2 bg-white shadow-md rounded-md">
            <h1 className="text-xl font-bold mb-4 text-center">Add Tasks</h1>
            <InputContainer
                label="Scheduled Task Type"
                labelField="Description"
                list={ScheduledTaskType.filter(item => item.Value !== 50)}
                onValueChange={(event: any) => {
                    onInnerBasicFormChange(
                        event.target.value,
                        'ScheduledTaskType'
                    );
                }}
                optionName='Choose Scheduled Task Type'
                type="select"
                value={selectEventTasks?.ScheduledTaskType}
                valueField="Value"
            />
            <div className="w-full p-2 bg-white shadow-md rounded-md">

                {selectEventTasks?.ScheduledTaskType === 10 && (
                    <InputContainer
                        label="Plat Forms"
                        labelField="Name"
                        list={platForms}
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                Number(event.target.value),
                                'PlatformScheduledTaskId'
                            );
                        }}
                        optionName="Choose Type"
                        type="select"
                        value={selectEventTasks?.PlatformScheduledTaskId}
                        valueField="Id"
                    />
                )}


                {selectEventTasks?.ScheduledTaskType === 20 && (
                    <InputContainer
                        label="Configurations"
                        labelField="Name"
                        list={configurationItem?.filter(
                            (item: any) => item.OwnerLevelId === selectEventTasks?.OwnerLevelId
                        )}
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                Number(event.target.value),
                                'ScheduleTaskConfigurationId'
                            );
                        }}
                        optionName="Choose Type"
                        type="select"
                        value={selectEventTasks?.ScheduleTaskConfigurationId}
                        valueField="Id"
                    />
                )}

            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-4 border p-4">
                <InputContainer
                    isDisabled
                    label="Name"
                    name="Name"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(event.target.value, 'Name');
                    }}
                    type="text"
                    value={selectEventTasks?.Name}
                />

                <InputContainer
                    label="TimeInterval"
                    name="TimeInterval"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(event.target.value, 'TimeInterval');
                    }}
                    type="number"
                    value={selectEventTasks?.TimeInterval}
                />



                <InputContainer
                    isDisabled
                    label="Enable"
                    name="IsEnabled"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(event, 'IsEnabled');
                    }}
                    type="checkbox"
                    value={selectEventTasks?.IsEnabled}
                />

                 <InputContainer
                    label="StartDateUtc"
                    name="StartDateUtc"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(event.target.value, 'StartDateUtc');
                    }}
                    type="date"
                    value={selectEventTasks?.StartDateUtc}
                />

                <InputContainer
                    label="EndDateUtc"
                    name="EndDateUtc"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(event.target.value, 'EndDateUtc');
                    }}
                    type="date"
                    value={selectEventTasks?.EndDateUtc}
                />
               
            </div>

            <h1 className="text-xl font-bold mb-4 text-center">Scheduled Commands</h1>
            <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-4 border p-4">
                <InputContainer
                    isDisabled
                    label="Command"
                    name="Command"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(event.target.value, 'Command');
                    }}
                    type="text"
                    value={selectEventTasks?.Command}
                />

                <InputContainer
                    isDisabled
                    label="Schedule Command Type"
                    labelField="Text"
                    list={sheduledType}
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'ScheduleCommandTypeId',
                        );
                    }}
                    optionName="Choose ScheduleCommandType"
                    type="select"
                    value={selectEventTasks?.ScheduleCommandTypeId}
                    valueField="Value"
                />

                <InputContainer
                    isDisabled
                    label="Instruction"
                    name="Instruction"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(event.target.value, 'Instruction');
                    }}
                    type="text"
                    value={selectEventTasks?.Instruction}
                />

                <InputContainer
                    isDisabled
                    label="DisplayOrder"
                    name="DisplayOrder"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(event.target.value, 'DisplayOrder');
                    }}
                    type="number"
                    value={selectEventTasks?.DisplayOrder}
                />
            </div>

            <div className="flex justify-end mt-6">
                <button
                    onClick={Close}
                    type="button"
                    className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
                >
                    Close
                </button>
                <button
                    className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
                    onClick={handleItemSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    );
}
